import { Heading, Paragraph } from '@expressable/syntax-ds';
import { useTranslation } from 'react-i18next';
import { PasswordReset } from '../PasswordReset';
import { LoginForm } from '../LoginForm';

const Login = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="text-center">
        <Heading level="h1" className="mb-8 text-center">
          {t('login.pageHeading')}
        </Heading>
        <Paragraph size="lg" variant="primary">
          {t('login.subTitle')}
        </Paragraph>
      </div>

      <LoginForm className="max-w-[327px] self-center" />
    </>
  );
};

const ResetPassword = () => {
  const { t } = useTranslation();

  return (
    <>
      <PasswordReset className="max-w-[327px] self-center">
        {({ email }) => (
          <>
            <div className="text-center">
              <Heading level="h1" className="mb-8 text-center">
                {!email ? t('login.passwordReset.pageHeading') : t('login.passwordReset.pageHeading')}
              </Heading>
              <Paragraph size="lg" variant="primary">
                {!email ? t('login.passwordReset.step1.subTitle') : t('login.passwordReset.step2.subTitle')}
              </Paragraph>
            </div>
          </>
        )}
      </PasswordReset>
    </>
  );
};

export const LoginPages = {
  ResetPassword,
  Login,
};
